export default __webpack_public_path__ + "static/char-v-47-ja-4487631bfde0d42f55fa82b0769d048c.mp4";